export default {
  warning: {
    id: 'product_page_customization_keyboard_warning',
    defaultMessage:
      'This product’s keyboard differs from your country’s standard for now',
  },
  showMore: {
    id: 'product_page_customization_keyboard_more',
    defaultMessage: 'Show all options',
  },
}
